import { Box, BoxProps, ButtonNew, ColorOptions } from '@jfs/ui-new'
import { FC, useCallback } from 'react'
import { Colors } from '../../util/util'
import styles from './styles'
import { DayProps } from './types'

export enum ButtonStates {
  DEFAULT = 'default',
  DISABLED = 'disabled',
  ENABLED = 'enabled',
  SELECTED = 'selected',
  PRESELECTED = 'preselected',
}

const DayView: FC<DayProps> = ({
  day,
  onPress,
  type: calendarType,
  onHover,
  firstDate,
  hoverFrom,
  hoverTo,
}: DayProps) => {
  let state: ButtonStates = ButtonStates.ENABLED

  const setHoveredDate = useCallback((date) => onHover(date), [onHover])

  if (!day.isEnabled) {
    state = ButtonStates.DISABLED
  } else if (day.isSelected) {
    state = ButtonStates.SELECTED
  } else if (day.isPreSelected) {
    state = ButtonStates.PRESELECTED
  }

  const title = day.d > 0 ? day.d.toString() : ''

  const handleHover = (hover): void => {
    const selectedDate = firstDate?.getDate()
    day.d > 0 && selectedDate > 0 && day.isEnabled && hover ? setHoveredDate(day) : setHoveredDate(null)
  }

  const getHoverStyle = (): BoxProps => {
    let hoverStyle = {} as BoxProps
    const iDate = new Date(`${day.m + 1}/${day.d}/${day.y}`)?.getTime()
    if (hoverFrom < iDate && iDate <= hoverTo) {
      hoverStyle = { bg: Colors.CalendarColor as ColorOptions }
    }
    return { ...styles[calendarType].DateContainer, ...hoverStyle }
  }

  return (
    <Box onHover={handleHover} testID="dayview-onhover" onPress={() => null} underlayColor={'TRANSPARENT'}>
      <Box {...getHoverStyle()}>
        <ButtonNew
          testID={'dayview-' + title + state}
          title={title}
          type={'custom'}
          {...styles.Range.buttonType.default}
          {...styles.Range.buttonType[state]}
          onPress={onPress}
        />
      </Box>
    </Box>
  )
}

export default DayView
